import * as Sentry from '@sentry/react'
import { useRouteError } from 'react-router-dom'
import AppError from './components/AppError/AppError'

export const RouteErrorBoundary = Sentry.withErrorBoundary(
    () => {
        const error = useRouteError()
        throw error // Let Sentry catch it via the HOC
    },
    {
        fallback: <AppError />,
    },
)
